import React from 'react';

const Salary = React.lazy(() => import('pages/Salary/SalaryPage.jsx'));

const SalaryRoute = [
  {
    path: '/salary',
    exact: true,
    name: 'Bảng lương',
    component: Salary,
  },
];

export default SalaryRoute;
